import { render, staticRenderFns } from "./CreateCategoryModal.vue?vue&type=template&id=91be9c6e&"
import script from "./CreateCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CreateCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports